export default __webpack_public_path__ + "static/media/search-article.dc2a18b5.png";